<template lang="pug">
div
  announcement
  .container
    template(v-if="getLanguage == 'mn'")
      mnContent
    template(v-else)
      enContent
  //- seo
</template>

<script>
export default {
  components: {
    enContent: () => import("@/components/general/_general_en"),
    mnContent: () => import("@/components/general/_general_mn"),
    announcement: () => import("@/components/_announcement"),
    seo: () => import("@/components/_seo")
  },
  computed: {
    getLanguage() {
      return this.$store.getters.language
    },
  },
  mounted() {
    $('.info-menu ul li a').click(function(){
        var info_tab = $(this).data('tab');        
        $('.info-menu ul li a').removeClass('active');
        $(this).addClass('active');
        $('.accordion-item').removeClass('active');
        $('.accordion-item.'+info_tab).addClass('active');
    });
  }
}
</script>